var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map" }, [
    _vm.zone !== "world"
      ? _c("span", { staticClass: "goBack", on: { click: _vm.goBack } }, [
          _vm._v("返回 >"),
        ])
      : _vm._e(),
    _c("div", { ref: "mapContainer", staticClass: "map-container" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }